var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "741ebfac0fa51dd9f6ec1c919ff20ca64ea652e8"
};